import React, { useState, useRef } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { IoCutOutline, IoText } from "react-icons/io5";
import Sliders from "./Sliders";
import { MdModeEdit } from "react-icons/md";
import styles from "./video-highlight.module.css";
import { useDispatch, useSelector } from "react-redux";
import SelectAllOutlinedIcon from "@mui/icons-material/SelectAllOutlined";
import SelectionToolkit from "./SelectionToolkit";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {
  setToolkitUrl,
  setShowToolkit,
  setShowToolkitSecond,
} from "../../../Redux/Actions/VideoHighlightAction";
import {
  setEditIconClick,
  setShowTrimmer,
  setHandleDeletedVideo,
  setHandleVideoSelection,
  setText,
  setIsOverlayText,
  setShowSelectionToolkit,
  setVideoEditData,
  setOpenNameDialog,
} from "../../../Redux/Actions/VideoHighlightAction";
import HoverToolTip from "../../../Common/ToolTips/HoverToolTips/HoverToolTip";
function VideoSelection({
  maxDuration,
  videoRef,
  setVideoPath,
  setMaxDuration,
  videoPath,
  setPlaybackHandleValue,
  playbackHandleValue,
  setIsMerge,
}) {
  const [sliderValues, setSliderValues] = useState([]);
  const currentVideoRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [videoDuration, setVideoDuration] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const {
    selectedVideoPaths,
    duration,
    startTime,
    text,
    showSlider,
    showTrimmer,
    editIcons,
    isOverlayText,
    showSelectionToolkit,
  } = useSelector((state) => state?.videoHighlightData);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleVideoSelection = (video) => {
    setVideoPath(video?.path);
    setHandleVideoSelection(dispatch, {
      showSlider: false,
      showTrimmer: false,
      editIcons: false,
      showToolkit: false,
      isOverlayText: false,
      showSelectionToolkit: false,
    });
  };

  const handleAddTextIconClick = () => {
    if (isOverlayText) {
      setIsOverlayText(dispatch, false);
      setText(dispatch, "");
    } else {
      let checkText;
      setIsOverlayText(dispatch, true);
      selectedVideoPaths.some((selectedVideo) => {
        if (selectedVideo.path === videoPath) {
          checkText = selectedVideo.text;
          return true;
        }
      });
      if (checkText) {
        setText(dispatch, checkText);
      } else {
        setText(dispatch, "");
      }
    }
  };

  const handleMergeButtonClick = async () => {
    setIsMerge(true);
    setOpenNameDialog(dispatch, true);
  };

  const handleDoneButtonClick = async () => {
    setOpen(true);
    setVideoEditData(dispatch, {
      path: videoPath,
      startTime,
      duration,
      text,
    });
  };

  const handleCut = () => {
    if (showTrimmer) {
      setShowTrimmer(dispatch, false);
    } else {
      let checkStartTime;
      let checkDuration;
      setShowTrimmer(dispatch, true);
      selectedVideoPaths.some((selectedVideo) => {
        if (selectedVideo.path === videoPath) {
          checkStartTime = selectedVideo.startTime;
          checkDuration = selectedVideo.duration;
          return true;
        }
      });
      if (checkDuration && checkStartTime) {
        setSliderValues([checkStartTime, checkDuration]);
      } else {
        setSliderValues([1, 2]);
      }
    }
  };

  const handleVideoHover = (e, video, index) => {
    //setVideoDuration(formatDuration(video?.videoDuration));
    if (video?.videoPath.endsWith(".m3u8")) {
      setVideoDuration(formatDuration(video?.videoDuration));
    } else {
      setVideoDuration(video?.videoDuration);
    }
    setHoveredIndex(index);
    setShowTooltip(true);
  };

  const handleDeleteVideo = (index) => {
    const updatedVideosPath = selectedVideoPaths.filter((_, i) => i !== index);
    setHandleDeletedVideo(dispatch, {
      selectedVideoPaths: updatedVideosPath,
      showSlider: false,
      editIcons: false,
    });
    setIsOverlayText(dispatch, false);
    setVideoPath("");
    setToolkitUrl(dispatch, []);
    setShowSelectionToolkit(dispatch, false);
    setShowToolkit(dispatch, false);
    setShowToolkitSecond(dispatch, false);
  };

  const convertToSeconds = (input) => {
    // Split the input into minutes and fractional seconds
    const [minutes, fractionalSeconds] = input
      .toString()
      .split(".")
      .map(Number);
    //directly added fractional seconds as it is already in seconds
    // Calculate total seconds
    const totalSeconds = (minutes || 0) * 60 + fractionalSeconds;
    return totalSeconds;
  };

  const handleEditIconClick = (video) => {
    // setMaxDuration(video?.videoDuration);
    if (video?.videoPath?.endsWith(".m3u8")) {
      setMaxDuration(video?.videoDuration);
    } else {
      console.log("kvnv=>", convertToSeconds(video?.videoDuration));
      setMaxDuration(convertToSeconds(video?.videoDuration));
    }
    setVideoPath(video?.path);
    setEditIconClick(dispatch, {
      showSlider: true,
      startTime: selectedVideoPaths.startTime,
      duration: selectedVideoPaths.duration,
      text: selectedVideoPaths.text,
      videoPathForTrim: video,
      showTrimmer: false,
      isOverlayText: false,
      editIcons: true,
      showToolkit: false,
    });
  };

  const handleVideoLeave = () => {
    setHoveredIndex(null);
    setShowTooltip(false);
    setVideoDuration("");
  };

  const handleToolkitClick = () => {
    setShowSelectionToolkit(dispatch, !showSelectionToolkit);
  };

  const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Video edits have been successfully applied to the video.
        </Alert>
      </Snackbar>
      {selectedVideoPaths.length != 0 && (
        <div className={styles.mainRectangle}>
          <div className={styles.rectangleScroll}>
            {selectedVideoPaths?.map((video, index) => (
              <div
                key={index}
                className={`${styles.rectangle} ${
                  videoPath === video?.path ? styles.selected : ""
                }`}
              >
                <div className={styles.rectangleContent}>
                  {video?.thumbnailUrl ? (
                    <img
                      className={styles.videoWrapper}
                      src={video?.thumbnailUrl}
                      ref={currentVideoRef}
                      onClick={() => handleVideoSelection(video)}
                      onMouseOver={(e) => handleVideoHover(e, video, index)}
                      onMouseLeave={handleVideoLeave}
                    />
                  ) : (
                    <video
                      className={styles.videoWrapper}
                      src={video?.path}
                      ref={currentVideoRef}
                      onClick={() => handleVideoSelection(video)}
                      onMouseOver={(e) => handleVideoHover(e, video, index)}
                      onMouseLeave={handleVideoLeave}
                    />
                  )}
                  <span className={styles.videoName}>{video?.videoName}</span>
                  <MdModeEdit
                    className={`${styles.editIcon} ${styles.iconHoverEffect}`}
                    onClick={() => handleEditIconClick(video)}
                  />
                  <FaTrashAlt
                    className={`${styles.deleteIcon} ${styles.iconHoverEffect}`}
                    onClick={() => handleDeleteVideo(index)}
                  />
                  <div
                    className={`${styles.tooltip} ${
                      showTooltip && hoveredIndex === index
                        ? styles.visible
                        : ""
                    }`}
                  >
                    {videoDuration}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {showSlider && (
            <Sliders
              videoRef={videoRef}
              playbackHandleValue={playbackHandleValue}
              setPlaybackHandleValue={setPlaybackHandleValue}
              maxDuration={maxDuration}
              sliderValues={sliderValues}
              setSliderValues={setSliderValues}
            />
          )}
          {showSelectionToolkit && <SelectionToolkit />}
          {editIcons && (
            <div className={styles.iconWrapper}>
              <HoverToolTip
                content={
                  <span>
                    To save your edits, simply click Done after making changes
                    to the single video.
                  </span>
                }
                showToolTip={true}
                variant="sm"
                trigger="hover"
              >
                <button
                  className={`small-btn mg-top-10 ${styles.done}`}
                  onClick={handleDoneButtonClick}
                >
                  Done
                </button>
              </HoverToolTip>
              <HoverToolTip
                content={<span>Cut the video.</span>}
                showToolTip={true}
                variant="sm"
                trigger="hover"
              >
                <IoCutOutline
                  className={`${styles.cutIcon} ${styles.iconHoverEffect}`}
                  onClick={() => handleCut()}
                />
              </HoverToolTip>
              <HoverToolTip
                content={<span>Add title to the video.</span>}
                showToolTip={true}
                variant="sm"
                trigger="hover"
              >
                <IoText
                  className={`${styles.textIcon} ${styles.iconHoverEffect}`}
                  onClick={handleAddTextIconClick}
                />
              </HoverToolTip>
              <HoverToolTip
                content={
                  <span>Highlight the object or players move from video.</span>
                }
                showToolTip={true}
                variant="sm"
                trigger="hover"
              >
                <SelectAllOutlinedIcon
                  className={`${styles.selectionIcon} ${styles.iconHoverEffect}`}
                  onClick={handleToolkitClick}
                />
              </HoverToolTip>
              <HoverToolTip
                content={
                  <span>
                    All videos will be edited individually and then merged into
                    a single video. If there is only one video, it will be
                    edited as a single video.
                  </span>
                }
                showToolTip={true}
                variant="sm"
                trigger="hover"
              >
                <button
                  className={`mg-top-10 ${styles.merge} ${
                    selectedVideoPaths[0]?.startTime ||
                    selectedVideoPaths[0]?.text
                      ? "small-btn"
                      : "small-btn small-btn-faint"
                  }`}
                  onClick={handleMergeButtonClick}
                  disabled={
                    !(
                      selectedVideoPaths[0]?.startTime ||
                      selectedVideoPaths[0]?.text
                    )
                  }
                >
                  Edit/Merge
                </button>
              </HoverToolTip>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default VideoSelection;
